import styled from 'styled-components';

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
`;

export const AboutWrapper = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  padding: 72px 50px;

  @media screen and (max-width: 786px) {
    padding: 48px 20px;
  }
`;

export const Interests = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 24px;
  grid-row-gap: 24px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const AboutCard = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #010606;
  border-radius: 8px;
  padding: 12px 16px;
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const AboutH1 = styled.h1`
  font-size: 2.5rem;
  color: #010606;
  margin-bottom: 24px;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const StyledIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;

  > svg {
    width: 100%;
    height: 100%;
  }
`;

export const AboutH2 = styled.h2`
  font-size: 1rem;
  color: #010606;
  margin: 0;
`;
